<template>
	<div>
		<cat-search-head
			:results="results"
			:filter="filter"
      :nullFilter="nullFilter"
			:suggestedFilters="suggestedFilters"
      :sortBy="sortBy"
		/>
		<vs-row>
			<cat-search-filters
				:filter="filter"
        :nullFilter="nullFilter"
				v-on:search="search()"
				v-on:clear="clearFilter()"
			/>
			<cat-search-results :filter="filter" :results="sortedResults" v-if="results" />
			<cat-search-spinner :loading="loading" v-else />
		</vs-row>
	</div>
</template>

<script>
import CatSearchHead from '@/components/cat/SearchHead.vue'
import CatSearchFilters from '@/components/cat/SearchFilters.vue'
import CatSearchResults from '@/components/cat/SearchResults.vue'
import CatSearchSpinner from '@/components/cat/SearchSpinner.vue'
import Vue from 'vue'
import axios from '@/axios.js'
export default {
  components: {
    CatSearchHead,
    CatSearchFilters,
    CatSearchResults,
    CatSearchSpinner
  },
  data () {
    const nullFilter = {
      region: [],
      date: null,
      duration: [1, 21],
      priceRange: [0, 500],
      cruiseLine: [],
      cabinType: [],
      importantAmenities: []
    }
    return {
      nullFilter: Object.assign({}, nullFilter),
      filter: Vue.observable(nullFilter),

      loading: false,
      results: null,
      suggestedFilters: null,
      sortBy: Vue.observable({
        field: 'matchingScore',
        order: 1
      })
    }
  },
  methods: {
    search () {
      const that = this
      this.loading = true
      axios
        .post('/api/data-list/cruises', this.filter)
        .then(function (resp) {
          that.results = resp.data.results
          that.suggestedFilters = resp.data.suggestedFilters
        })
        .catch(function (err) {
          console.log('ERROR', err)
        })
        .finally(function () {
          that.loading = false
        })
    },
    clearFilter () {
      console.log('CLEARING FILTER')
      this.filter = Vue.observable(Object.assign({}, this.nullFilter))
    }
  },
  computed: {
    sortedResults () {
      const that = this
      return this.results.slice(0).sort(function (a, b) {
        const s = that.sortBy
        if (a[s.field] < b[s.field]) {
          // a has a lower value for the sort field than b
          return 1 * s.order
        } else {
          return -1 * s.order
        }
      })
    }
  },
  watch: {
    filter: {
      handler () {
        this.search()
      },
      deep: true
    }
  },
  created () {
    // apply default filters from route, if any specified
    Object.assign(this.filter, this.$route.params.filter || {})
    Object.assign(this.sortBy, this.$route.params.sortBy || {})
  },
  mounted () {
    this.search()
  }
}
</script>
